export class AuthenticatedUser {

    constructor(
        public readonly email: string,
        public readonly id: number,
        public readonly impersonated: boolean) {
    }
}
